/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModuleWithScopes } from './ModuleWithScopes';
import {
    ModuleWithScopesFromJSON,
    ModuleWithScopesFromJSONTyped,
    ModuleWithScopesToJSON,
} from './ModuleWithScopes';

/**
 * 
 * @export
 * @interface GetAvailableModuleScopes200Response
 */
export interface GetAvailableModuleScopes200Response {
    /**
     * 
     * @type {Array<ModuleWithScopes>}
     * @memberof GetAvailableModuleScopes200Response
     */
    moduleWithScopes: Array<ModuleWithScopes>;
}

/**
 * Check if a given object implements the GetAvailableModuleScopes200Response interface.
 */
export function instanceOfGetAvailableModuleScopes200Response(value: object): value is GetAvailableModuleScopes200Response {
    if (!('moduleWithScopes' in value) || value['moduleWithScopes'] === undefined) return false;
    return true;
}

export function GetAvailableModuleScopes200ResponseFromJSON(json: any): GetAvailableModuleScopes200Response {
    return GetAvailableModuleScopes200ResponseFromJSONTyped(json, false);
}

export function GetAvailableModuleScopes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAvailableModuleScopes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'moduleWithScopes': ((json['moduleWithScopes'] as Array<any>).map(ModuleWithScopesFromJSON)),
    };
}

export function GetAvailableModuleScopes200ResponseToJSON(value?: GetAvailableModuleScopes200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'moduleWithScopes': ((value['moduleWithScopes'] as Array<any>).map(ModuleWithScopesToJSON)),
    };
}

